// Mock data for TT Pools website

export const services = [
  {
    id: 1,
    title: "New Pool Construction",
    description: "Custom-designed pools built to your specifications with premium materials and expert craftsmanship.",
    icon: "Construction"
  },
  {
    id: 2,
    title: "Pool Renovations",
    description: "Transform your existing pool with modern upgrades, resurfacing, and aesthetic improvements.",
    icon: "Paintbrush"
  },
  {
    id: 3,
    title: "Solar Heating Installations",
    description: "Energy-efficient solar heating systems to extend your swimming season year-round.",
    icon: "Sun"
  },
  {
    id: 4,
    title: "Marbelite & Re-Marbeliting",
    description: "Professional marbelite application and resurfacing for a smooth, durable pool finish.",
    icon: "Gem"
  },
  {
    id: 5,
    title: "Pump & Filter Repairs",
    description: "Expert diagnosis and repair of pool pumps and filtration systems to keep water crystal clear.",
    icon: "Settings"
  },
  {
    id: 6,
    title: "Weir & Underwater Light Repairs",
    description: "Restore functionality and ambiance with professional weir and lighting repairs.",
    icon: "Lightbulb"
  },
  {
    id: 7,
    title: "Leak Detection & Repairs",
    description: "Advanced leak detection technology and expert repairs to prevent water loss.",
    icon: "Search"
  },
  {
    id: 8,
    title: "Chlorination System Installation",
    description: "Automated chlorination systems for consistent water quality with minimal maintenance.",
    icon: "Droplets"
  },
  {
    id: 9,
    title: "Changing Filter Sand",
    description: "Regular filter sand replacement to maintain optimal filtration efficiency.",
    icon: "RefreshCw"
  },
  {
    id: 10,
    title: "Jacuzzi Installation",
    description: "Luxury jacuzzi installations for the ultimate relaxation experience at home.",
    icon: "Waves"
  }
];

export const galleryImages = [
  {
    id: 1,
    before: "https://customer-assets.emergentagent.com/job_swim-solutions-9/artifacts/396m1rb0_WhatsApp%20Image%202026-02-08%20at%2011.54.56%20%282%29.jpeg",
    after: "https://customer-assets.emergentagent.com/job_swim-solutions-9/artifacts/z2cl21xh_WhatsApp%20Image%202026-02-08%20at%2011.54.58.jpeg",
    title: "Pool Construction - Complete Build"
  },
  {
    id: 2,
    before: "https://customer-assets.emergentagent.com/job_swim-solutions-9/artifacts/4pnf3bkm_WhatsApp%20Image%202026-02-08%20at%2011.54.57.jpeg",
    after: "https://customer-assets.emergentagent.com/job_swim-solutions-9/artifacts/ecuh1n7c_WhatsApp%20Image%202026-02-08%20at%2011.54.57%20%282%29.jpeg",
    title: "Marbelite Resurfacing Project"
  },
  {
    id: 3,
    before: "https://customer-assets.emergentagent.com/job_swim-solutions-9/artifacts/u5ffi4od_WhatsApp%20Image%202026-02-08%20at%2011.54.57%20%281%29.jpeg",
    after: "https://customer-assets.emergentagent.com/job_swim-solutions-9/artifacts/skrgqo6c_WhatsApp%20Image%202026-02-08%20at%2011.54.56%20%281%29.jpeg",
    title: "Pool Renovation - Tile Work"
  },
  {
    id: 4,
    before: "https://customer-assets.emergentagent.com/job_swim-solutions-9/artifacts/axslgke4_WhatsApp%20Image%202026-02-08%20at%2011.54.56.jpeg",
    after: "https://customer-assets.emergentagent.com/job_swim-solutions-9/artifacts/z2cl21xh_WhatsApp%20Image%202026-02-08%20at%2011.54.58.jpeg",
    title: "Premium Pool Finishing"
  }
];

export const contactInfo = {
  email: "TTpools2@gmail.com",
  phone: "072 534 4906",
  contactPerson: "Trevor",
  companyName: "TT Pools (Pty) Ltd"
};

export const aboutContent = {
  title: "About TT Pools",
  description: `With over two decades of experience in the swimming pool industry, TT Pools (Pty) Ltd has established itself as a trusted name in pool construction, renovation, and maintenance across South Africa.

Our team of skilled professionals is dedicated to delivering exceptional quality and service on every project. From new pool construction to complex repairs, we approach each job with the same commitment to excellence.

We understand that your pool is an investment in your home and lifestyle. That's why we use only premium materials, employ industry-best practices, and stand behind our work with comprehensive warranties.`,
  highlights: [
    "20+ Years of Experience",
    "Licensed & Insured",
    "Premium Materials Only",
    "Satisfaction Guaranteed"
  ]
};

export const navLinks = [
  { href: "#home", label: "Home" },
  { href: "#services", label: "Services" },
  { href: "#about", label: "About" },
  { href: "#gallery", label: "Gallery" },
  { href: "#contact", label: "Contact" }
];
